import {LogRegLogo} from "../util/LogRegLogo";
import React, {useEffect, useState} from "react";
import {Button, Input} from "antd";
import {LeftOutlined} from "@ant-design/icons";
import {isValidEmail} from "../../util/utils";
import {NavLink} from "react-router-dom";

interface LoginPageEmailProps {
  email: string;
  password: string;
  error: string;
  loading: boolean;
  onEmailChange: (email: string) => void;
  onPasswordChange: (password: string) => void;
  step: 'email' | 'password' | 'forgot-password',
  onNext: () => void;
  onBack: () => void;
}

export default function LoginPageStep({step, email, loading, error, password, onEmailChange, onPasswordChange, onNext, onBack}: LoginPageEmailProps) {
  const [submitDisabled, setSubmitDisabled] = useState(true);

  useEffect(() => {
    setSubmitDisabled(
      (step === 'email' && !emailValid(email)) ||
      (step === 'password' && (!emailValid(email) || !passwordValid(password))) ||
      (step === 'forgot-password' && !emailValid(email)));
  }, [step, email, password]);

  function submitOnEnter(code: string) {
    if (code === 'Enter') {
      validateAndProceed();
    }
  }

  function emailValid(email: string) {
    return !!email && isValidEmail(email);
  }

  function passwordValid(password: string) {
    return !!password;
  }

  function validateAndProceed() {
    if (step === 'email' && emailValid(email)) {
      onNext();
    }
    if (step === 'password' && passwordValid(password) && emailValid(email)) {
      onNext();
    }
    if (step === 'forgot-password' && emailValid(email)) {
      onNext();
    }
  }


  return (
    <div className={"step-type step full"}>
      <div className={'back'} onClick={onBack}><LeftOutlined/></div>
      <LogRegLogo/>
      {step !== 'forgot-password' && <h2>Log in with email</h2>}
      {step === 'forgot-password' && <h2>Forgot your password?</h2>}

      {step === 'email' && <h5>We'll check if you have an account, and help create one if you don't.</h5>}
      {step === 'password' && <h5>Enter your password for {email}</h5>}
      {step === 'forgot-password' && <h5>Enter the email address you registered with and we'll email you a new password.</h5>}

      {error && <h6 className={"err"}>{error}</h6>}

      <div className="login-buttons">
        {(step === 'email' || step === 'forgot-password') &&
          <Input type={"email"} placeholder={"Email"} value={email} size={"large"} autoFocus autoComplete={step === 'forgot-password' ? undefined : 'username'}
                 onChange={ev => onEmailChange(ev.target.value?.trim().toLowerCase())}
                 onKeyUp={ev => submitOnEnter(ev.key)}
          />}
        {step === 'password' && <Input.Password placeholder={"Password"} value={password} size={"large"} autoFocus autoComplete="current-password"
                                                onChange={ev => onPasswordChange(ev.target.value?.trim())}
                                                onKeyUp={ev => submitOnEnter(ev.key)}
        />}
        <Button
          size={"large"}
          className={"primary"}
          onClick={validateAndProceed}
          loading={loading}
          disabled={submitDisabled}>
          {step === 'forgot-password' ? 'Submit' : 'Next'}
        </Button>
      </div>
      <div className={`f-pass ${step !== 'password' ? 'hidden' : ''}`}>
        <NavLink to={"/account/password"} state={{email}}>Forgot your password?</NavLink>
      </div>
    </div>
  );
}
